import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes, timePhaseTypes} from '../../util/uiconstants';

export default function milestoneDetailsReducer(state = initialstate.milestoneDetailsForDashboard, action) {
	switch (action.type) {
		case types.GET_MILESTONE_DETAILS: {
			if (action.response && action.response.items && action.response.items.length > 0) {
				let newState = _.cloneDeep(action.response);
				if (action.filterAuditPhaseMilestone) {
					newState['items'] = _.filter(newState.items, (item) => {
						return item.taskOpenCount + item.taskInProgressCount + item.taskInReviewCount + item.taskCompleteCount > 0;
					});
				}
				newState['auditPhaseId'] = action.response && action.response.defaultTab;
				return newState;
			}
			return state;
		}

		case types.UPDATE_MILESTONE_DATA: {
			return Object.assign({}, state, action.data);
		}

		default:
			return state;
	}
}
